import { render, staticRenderFns } from "./AdminAutomaticQuestionnaireAnswer.vue?vue&type=template&id=368edebe&scoped=true&"
import script from "./AdminAutomaticQuestionnaireAnswer.vue?vue&type=script&lang=ts&"
export * from "./AdminAutomaticQuestionnaireAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./AdminAutomaticQuestionnaireAnswer.vue?vue&type=style&index=0&id=368edebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368edebe",
  null
  
)

export default component.exports